export default __webpack_public_path__ + "static/media/feeling_2_mobile_view.575bf248.svg";